import React from 'react'
import Header, { listImage } from '../../components/header/header'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import TitleSection from '../../components/title-section/title-section'
import { listFeature, listOfferItem } from '../landing/data'
import OfferItem from '../landing/components/offer-item/offer-item'
import CustomSlider from '../../components/custom-slider/custom-slider'
import Slider from "react-slick";
import SectionTC from '../../components/section-tc/section-tc'
import PaymentMethods from '../landing/components/payment-methods/payment-methods'
import styled from 'styled-components'
import { device } from '../../config/theme/breakpoints'
import FeatureItem from '../landing/components/feature-item/feature-item'
import ItemService from './components/item-service/item-service'
import { listServices } from './data'

const BodyHeaderContainer = styled.div`
  color: white;
  text-align: center;
  width: 100%;
  padding: 80px 0 50px;

  > div span{
    font-size: 12px;
  }

  @media ${device.tablet}{
    padding: 120px 0 50px;
  }
`
const PreTitle = styled.h3`
  font-style: italic;
  margin-bottom: 10px;
  font-weight: lighter;
  text-transform: uppercase;
  margin: 0;
  margin-top: 50px;
`
const Title = styled.h1`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 40px;
  text-transform: uppercase;
  position: relative;
  width: fit-content;
  margin: auto;
  padding-bottom: 5px;
  margin-bottom: 40px;
`
const TitleBar = styled.div`
    width: 30px;
    height: 7px;
    background: ${p => p.theme.palette.secondary.main};
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 6px 0 15px 6px;
    transform: skew(-30deg);
`
const ContainerServices = styled.div``

const FeatureCustomClass = `
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 15px;
  padding-top: 5px;
  padding-bottom: 5px;

  @media ${device.mobileL}{
    justify-content: space-around;
  }
`

const Services: React.FunctionComponent = () => {
  const sliderOfferRef = React.useRef<Slider>(null);

  return (
    <Layout>
        <Header images={listImage}>
          <BodyHeaderContainer>
            <SectionTC>
              <PreTitle>Experimenta</PreTitle>
              <Title>
                Nuestros servicios
                <TitleBar />
              </Title>
              <span>Viaja con la mayor comodidaden los buses más modernos</span>
            </SectionTC>
          </BodyHeaderContainer>
        </Header>
        <HeaderOptions>
          <SectionTC className={FeatureCustomClass}>
            {listFeature.map(feature => (
              <FeatureItem
                key={feature.id}
                icon={feature.icon}
                title={feature.title}
                subTitle={feature.subTitle}
                description={feature.description}
              />
            ))}
          </SectionTC>
        </HeaderOptions>
        <SectionTC>
          <TitleSection preTitle='Servicios' title='Te ofrecemos'/>
          <ContainerServices>
            {listServices.map(service => (
              <ItemService
                key={Date.now()}
                image={service.image}
                preTitle={service.preTitle}
                title={service.title}
                description={service.description}
                listOptions={service.listOptions}
                to={service.to}
              />
            ))}
          </ContainerServices>
        </SectionTC>
        <SectionTC>
          <PaymentMethods />
        </SectionTC>
        <CustomSlider
          sliderRef={sliderOfferRef}
          preTitle='Principales destinos'
          title='Y promociones'
          size={listOfferItem.length}
          withIconRight
        >
          {listOfferItem.map(offer => (
            <div key={offer.id}>
              <OfferItem
                  tour={offer.tour}
                  price={offer.price}
                  title={offer.title}
                  subTitle={offer.subTitle}
                  image={offer.image}
                />
            </div>
          ))}
        </CustomSlider>
    </Layout>
  )
}

export default Services